import React from 'react';
import ReactDOM from 'react-dom/client';
import App from "./domains/common/components/App";
import axios from "axios";
import {redirectToAckAccess} from "./pages/ackAccess";
import { redirectToMainPage, redirectToOauthPage } from './pages/oauthPage';
import {getBackendURL} from "./fn";
import {dealData} from "./pages/deal/deal";

document.dd = () => console.log(dealData);
const root = ReactDOM.createRoot(document.getElementById('root'));

const checkAuth = async () => {
  if (
    window.location.pathname.includes('ackaccess') ||
    window.location.pathname.includes('oauth/callback') ||
    window.location.pathname.includes('oauth/error') ||
    window.location.pathname.includes('main')
  ) {
    root.render(<App/>);
    return;
  }
  
  const backendUrl = getBackendURL();

  await new Promise((resolve) => {
    axios.get(`${backendUrl}/oauth/check/`, {
      withCredentials: true,
      headers: {
        'Accept': '*/*',
        'content-type': 'application/json'
      },
    }).then((response) => {
      if (response.status === 200) {
        root.render(<App/>);

        const script = document.createElement("script");
        script.src = "https://omni2.etagi.com/omni-lead/front/widget/iv6yapwkti73xmi1myt3184d8ngf8e4i";
        script.async = true;
        document.body.appendChild(script);
      }
      else if(response?.status === 461) {
        redirectToAckAccess();
      }
      else {
        redirectToOauthPage();
      }
    }).catch((error) => {
      if(error?.response?.status === 461) {
        redirectToAckAccess();
      } else {
        redirectToOauthPage();
      }
    });
  })
}

checkAuth();